module.exports = __webpack_public_path__ + "assets/img/46@3x.cd8019af.png";